
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/about",
      function () {
        return require("private-next-pages/[locale]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/about"])
      });
    }
  